module.exports = __webpack_public_path__ + "media/images/design/images/h2_volunteer-0a78300bd0600006966f2ea07beee811.png";